const globalMixin = {
  data() {
    return {
      loader: false,
      isMounted: false,
      isCreated: false,
    };
  },
  filters: {
    newLineToBr(value) {
      return value.replace(/\n/gim, '<br>');
    },
  },
  methods: {
    $confirm({ title = 'Emin misiniz?', body = null }) {
      this.$confirmCloseAll();

      return new Promise(resolve => {
        this.$dialog
          .confirm({ title, body })
          .then(response => {
            resolve(response);
          })
          .catch(response => {
            resolve(response);
          });
      });
    },
    $confirmCloseAll() {
      const bodyClasses = document
        .getElementsByTagName('body')[0]
        .classList.toString();

      if (bodyClasses.indexOf('dg-open') !== -1)
        this.$dialog.$root.forceCloseAll();
    },
    getMediaUrl({ media = null, usePath = 'securePath' }) {
      let url = null;

      if (media && media instanceof Object && media[usePath]) {
        const isRelative = !/^https?:\/\//i.test(media[usePath]);
        const contentType = media['contentType'];

        url = media[usePath];

        if (isRelative) {
          if (contentType.indexOf('image') > -1) {
            url = `${process.env.VUE_APP_S3_IMG_BASE_URL}${media[usePath]}`;
          } else if (contentType.indexOf('video') > -1) {
            url = `${process.env.VUE_APP_S3_VIDEO_BASE_URL}${media['securePath']}`;
          } else {
            url = `${process.env.VUE_APP_S3_ASSETS_BASE_URL}${media['securePath']}`;
          }
        }
      }
      return url;
    },
  },
  mounted() {
    this.isMounted = true;
  },
  created() {
    this.isCreated = true;
  },
};

export default globalMixin;
